module.exports = __webpack_public_path__ + "img/ring_r_skip_null_0@2x.65598e77.png";